"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
const zod_1 = require("zod");
exports.Timestamp = zod_1.z.number().safe().finite().int();
//# sourceMappingURL=validation.js.map